import { Controller } from 'react-hook-form';

import { CalendarIcon } from '@/assets/icons';
import { DateRangePicker } from '@/components/common';
import { ERROR_REQUIRED_FIELD } from '@/constants';

import { IGuestProfileCreationSection } from '@/features/face-id-profiles';

const GuestProfileSection = ({
  errors,
  control,
  formFields,
  setValue,
  trigger,
}: IGuestProfileCreationSection) => {
  return (
    <Controller
      name={formFields.guestValidFrom}
      control={control}
      rules={{
        validate: (_, formValues) =>
          formValues.guestValidFrom && formValues.guestValidTo ? true : ERROR_REQUIRED_FIELD,
      }}
      render={() => (
        <DateRangePicker
          align="start"
          label="Guest Valid Period"
          prefixIcon={<CalendarIcon />}
          required
          calendarDisabled={{ before: new Date() }}
          onUpdate={({ range }) => {
            setValue(formFields.guestValidFrom, range.from);
            setValue(formFields.guestValidTo, range.to);
            trigger(formFields.guestValidFrom);
          }}
          error={errors[formFields.guestValidFrom]?.message}
        />
      )}
    />
  );
};

export default GuestProfileSection;
